import React from "react";
import ProjectCardFilter from "./ProjectCardFilter";

function ProjectWrap(props) {
  return (
    <>
      <div className="project-area sec-mar">
        <div className="container">
          <div className="title-wrap">
            <div className={`${"sec-title"} ${props.white}`}>
              <span>e-Brandy</span>
              <h2>Proiecte</h2>
              <p> Câteva dintre proiectele noastre în vederea digitalizării afacerilor. Ne bucurăm de fiecare în parte și le suntem alături oricând.
                 
              </p>
            </div>
          </div>
          <ProjectCardFilter/>
        </div>
      </div>
    </>
  );
}

export default ProjectWrap;
